import { Box, makeStyles, Typography, Button } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import moment from 'moment';
import React from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import { IDebtor } from '../../models/Inquiry/IDebtor';
import { ITransactionHistory } from '../../models/Inquiry/TransactionHistory/ITransactionHistory';
import { useGlobalState } from '../../store/GlobalStore';
import LoadMore from '../../images/Icons/LoadMore.svg';

const useStyles = makeStyles((theme) => ({
    tabs: {
        backgroundColor: theme.palette.primary.main,
        marginRight: "2px",
        marginTop: "0%",
        width: "15%",
    },
    root: {
        border: "2px solid black",
        borderRadius: 8,
        height: "80%",
        marginTop: "7px"
    },
    girdView: {
        color: "blue",
        margin: '0px'
    },
    norecord: {
        color: "red",
        fontSize: 15
    },
    loadmorebutton: {
        borderRadius: 10,
        textIndent: '5px',
        fontSize: 10,
    },
    image: {
        width: '17px',
        height: '17px',
        display: 'flex',
    },
}))

const AccountHistory: React.FC<{ debtors: IDebtor, histories: ITransactionHistory[], mapped: boolean, handleLoadMore: () => void }> = (props) => {
    const { histories, mapped, handleLoadMore } = props;
    const classes = useStyles();
    const { state, dispatch } = useGlobalState();

    const useProgressStyles = makeStyles((theme) => ({
        root: {
            position: 'relative',
        },
        bottom: {
            color: theme.palette.grey[theme.palette.type === 'light' ? 200 : 700],
        },
        top: {
            color: '#1a90ff',
            animationDuration: '550ms',
            position: 'absolute',
            left: 0,
        },
        circle: {
            strokeLinecap: 'round',
        },
    }));

    function Progress(props) {
        const classes = useProgressStyles();
        return (
            <div className={classes.root}>
                <CircularProgress
                    variant="determinate"
                    className={classes.bottom}
                    size={30}
                    thickness={4}
                    {...props}
                    value={100}
                />
                <CircularProgress
                    variant="indeterminate"
                    disableShrink
                    className={classes.top}
                    classes={{
                        circle: classes.circle,
                    }}
                    size={30}
                    thickness={4}
                    {...props}
                />
            </div>
        );
    }

    return (
        <React.Fragment >
            <Box display="flex" alignItems="center" justifyContent="space-between">
                <h4 className={classes.girdView}>Notes</h4>

                <Button id="Inquiry_LoadAll_Button" className={classes.loadmorebutton} variant="contained" color="primary" onClick={handleLoadMore} >
                    <img src={LoadMore} alt="Load_More" className={classes.image} />
                    Load More
                </Button>
            </Box>
            <Box p={1} width="100%" flexShrink={0} bgcolor="white" className={classes.root} >
                <Scrollbars autoHide
                    autoHideTimeout={1000}
                    autoHideDuration={10}
                    autoHeight
                    autoHeightMin={140}
                    autoHeightMax={140}
                    style={{ width: "100%" }}>
                    {mapped ?
                        histories.map((Histories) => {
                            if (Histories.activityType !== "0") {
                                return (
                                    <p style={Histories.activityType === "T" ? { color: "#009900", fontSize: 13 } : { color: "black", fontSize: 13 }}>
                                        {moment(Histories.activityDt).format(state.GlobalUtils?.settingValue)}
                                        &nbsp;{Histories.activity?.split('|')[0]}
                                    </p>
                                )
                            } else {
                                return (
                                    <Typography variant="subtitle1" gutterBottom className={classes.norecord}>
                                        <b>No Records to Display</b>
                                    </Typography>
                                )
                            }
                        })
                        : <Progress />}
                </Scrollbars>
            </Box>
        </React.Fragment>
    )
}

export default AccountHistory
